"use client";

import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    if (process.env.NODE_ENV !== "production") {
      console.error("Global error:", error);
    }
  }, [error]);

  return (
    <html>
      <body>
        <main
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "1.5rem",
            fontFamily: "system-ui, -apple-system, sans-serif",
            backgroundColor: "#0f0f12",
            color: "#f5f5f5",
          }}
        >
          <div
            style={{
              maxWidth: 420,
              width: "100%",
              padding: "2rem",
              borderRadius: 16,
              border: "1px solid rgba(255,255,255,0.08)",
              background: "rgba(255,255,255,0.02)",
              textAlign: "center",
            }}
          >
            <div
              style={{
                width: 56,
                height: 56,
                margin: "0 auto 1rem",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "rgba(239,68,68,0.12)",
                color: "#f87171",
                fontSize: 22,
              }}
              aria-hidden="true"
            >
              !
            </div>
            <h1 style={{ fontSize: 18, fontWeight: 600, margin: 0 }}>
              Something went wrong
            </h1>
            <p
              style={{
                margin: "0.5rem 0 1.25rem",
                fontSize: 14,
                opacity: 0.7,
                lineHeight: 1.5,
              }}
            >
              An unexpected error occurred. Try again, or reload the page if it
              keeps happening.
            </p>
            {error?.digest ? (
              <p
                style={{
                  fontFamily: "monospace",
                  fontSize: 11,
                  opacity: 0.4,
                  marginBottom: "1rem",
                }}
              >
                Reference: {error.digest}
              </p>
            ) : null}
            <button
              type="button"
              onClick={reset}
              style={{
                padding: "0.6rem 1.25rem",
                borderRadius: 8,
                border: "1px solid rgba(255,255,255,0.15)",
                background: "#2563eb",
                color: "white",
                fontSize: 14,
                fontWeight: 500,
                cursor: "pointer",
              }}
            >
              Try again
            </button>
          </div>
        </main>
      </body>
    </html>
  );
}
